/**
 * Copyright (C) 2022 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import { toNumber } from 'lodash';

export const getLinearGradient = (currentUsage: any, totalUsage: number): string => {
  let first = (toNumber(currentUsage) / totalUsage) * 100;
  first = first <= 100 ? first : 100;
  let second = (1 - toNumber(currentUsage) / totalUsage) * 100;
  second = second <= 100 ? second : 100;
  const trackColorHex = '#111920';
  const amountColorHex = '#202E39';
  const linearGradient = `linear-gradient(to right, ${amountColorHex} 0% ${first}%, ${trackColorHex} ${first}% ${second}%)`;

  return linearGradient;
};
